<template>
  <div class="cavendish-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F = G · (m1·m2 / r²) | G ≈ 6.67e-11$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Torsion Wire -->
          <line x1="200" y1="20" x2="200" y2="80" stroke="#888" stroke-width="1" stroke-dasharray="2" />
          
          <!-- Beam and Small Lead Balls (m) -->
          <g :transform="`translate(200, 80) rotate(${angle})`">
             <line x1="-60" y1="0" x2="60" y2="0" stroke="#555" stroke-width="2" />
             <circle cx="-60" cy="0" r="8" fill="#aaa" />
             <circle cx="60" cy="0" r="8" fill="#aaa" />
             <text x="-55" y="-12" fill="#888" font-size="8">m</text>
          </g>

          <!-- Large Lead Balls (M) -->
          <g v-if="massOn">
             <circle :cx="200 - 80" :cy="80 - 20" r="20" fill="#333" stroke="#888" />
             <circle :cx="200 + 80" :cy="80 + 20" r="20" fill="#333" stroke="#888" />
             <text x="110" y="50" fill="#888" font-size="10">M</text>
          </g>

          <!-- Laser Indicator on Wall -->
          <g transform="translate(350, 40)">
             <rect width="10" height="160" fill="#111" stroke="#333" />
             <circle cx="5" :cy="80 + angle" r="3" fill="#ff4757">
                <animate attributeName="opacity" values="1;0.5;1" dur="0.5s" repeatCount="indefinite" />
             </circle>
             <text x="-5" y="10" fill="#888" font-size="8" transform="rotate(-90, -5, 10)">反射光点</text>
          </g>

          <!-- Laser Ray -->
          <line x1="200" y1="80" x2="350" :y2="120 + angle" stroke="#ff4757" stroke-dasharray="2" opacity="0.3" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>偏转角度 θ: {{ (angle/10).toFixed(2) }}°</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <el-checkbox v-model="massOn">放置大质量铅球 M</el-checkbox>
          </div>
          <div class="row">
             <div class="status-tag" :style="{ color: massOn ? '#00d2ff' : '#888' }">
                {{ massOn ? '引力矩产生中...' : '平衡态' }}
             </div>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>由于引力极其微弱，卡文迪什巧妙地利用了**扭秤**来放大效果。当大球靠近小球时，引力导致横梁发生极其微小的转动，通过反射镜将光束投射到远处，光点的位移可以精确测量出扭转角。这直接测定了**万有引力常数 G**，从而“称量”出了地球的质量。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CavendishExperimentViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      massOn: false,
      angle: 0,
      timer: null
    }
  },
  methods: {
    update() {
      const targetAngle = this.massOn ? 15 : 0;
      this.angle += (targetAngle - this.angle) * 0.05;
      this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.cavendish-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.status-tag { font-size: 0.75rem; border: 1px solid currentColor; padding: 4px 10px; border-radius: 4px; }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
